export default function Panel({ title, description, right, children, className = "" }) {
  const panelClassName = className ? `panel ${className}` : "panel";

  return (
    <section className={panelClassName}>
      {(title || description || right) && (
        <div className="panel-head">
          <div>
            {title ? <h2>{title}</h2> : null}
            {description ? <p>{description}</p> : null}
          </div>
          {right}
        </div>
      )}
      {children}
    </section>
  );
}
